export const stateReducer = (state, action) => {
    switch (action.type) {
        case 'changeFirstName': {
            return {
                ...state,
                firstName: action.payload,
            };
        }
        case 'changeLastName': {
            return {
                ...state,
                lastName: action.payload,
            };
        }
        case 'changeMiddleName': {
            return {
                ...state,
                middleName: action.payload,
            };
        }
        case 'changeSex': {
            return {
                ...state,
                sex: action.payload,
            };
        }
        case 'changeBirthday': {
            return {
                ...state,
                birthday: action.payload,
            };
        }
        case 'changeResidentStatus': {
            return {
                ...state,
                residentStatus: action.payload,
            };
        }
        case 'changeInn': {
            return {
                ...state,
                inn: action.payload,
            };
        }
        case 'changeSnils': {
            return {
                ...state,
                snils: action.payload,
            };
        }
        case 'changeEmail': {
            return {
                ...state,
                email: action.payload,
            };
        }
        case 'changeCitizenship': {
            return {
                ...state,
                citizenship: action.payload,
            };
        }
        case 'changePhone': {
            return {
                ...state,
                phone: action.payload,
            };
        }
        case 'changeCardMIR': {
            return {
                ...state,
                mirCard: action.payload,
            };
        }
        case 'changeBankAccountName': {
            return {
                ...state,
                bankAccount: {
                    ...state.bankAccount,
                    name: action.payload,
                },
            };
        }
        case 'changeBankAccountBIK': {
            return {
                ...state,
                bankAccount: {
                    ...state.bankAccount,
                    bik: action.payload,
                },
            };
        }
        case 'changeBankAccountPayment': {
            return {
                ...state,
                bankAccount: {
                    ...state.bankAccount,
                    paymentAccount: action.payload,
                },
            };
        }
        case 'changeOtherOrgName': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    name: action.payload,
                },
            };
        }
        case 'changeOtherOrgInn': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    inn: action.payload,
                },
            };
        }
        case 'changeOtherOrgBik': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    bik: action.payload,
                },
            };
        }
        case 'changeOtherOrgPaymentAccount': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    paymentAccount: action.payload,
                },
            };
        }
        case 'changeOtherOrgAccount': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    account: action.payload,
                },
            };
        }
        case 'changeOtherOrgRecipientAccount': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    recipientAccount: action.payload,
                },
            };
        }
        case 'changeOtherOrgKbk': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    kbk: action.payload,
                },
            };
        }
        case 'changeRegistrationAddress': {
            return {
                ...state,
                registrationAddress: action.payload,
            };
        }
        case 'changeHomeAddress': {
            return {
                ...state,
                homeAddress: action.payload,
            };
        }
        case 'changeOtherOrgRegistrationNumber': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    registrationNumber: action.payload,
                },
            };
        }
        case 'changeOtherOrgKpp': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    kpp: action.payload,
                },
            };
        }
        case 'changeIdentityDocuments': {
            return {
                ...state,
                identityDocuments: action.payload,
            };
        }
        case 'changeActiveIdentityDocumentId': {
            return {
                ...state,
                activeIdentityDocumentId: action.payload,
            };
        }
        case 'changeIdentityDocumentEditStatus': {
            return {
                ...state,
                identityDocumentEditStatus: action.payload,
            };
        }
        case 'changeOtherOrgRegistrationNumberSfr': {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    registrationNumberSfr: action.payload,
                },
            };
        }
        case 'changeFormStatus': {
            return {
                ...state,
                formStatus: action.payload,
            };
        }
        case 'changeMatchValue': {
            return {
                ...state,
                matchFields: action.payload,
            };
        }
        case 'changeTabStatus': {
            return {
                ...state,
                tabStatus: action.payload,
            };
        }
        case 'changeMatchValidationLevel': {
            return {
                ...state,
                matchValidationLevel: action.payload,
            };
        }
    }
};
